import React from 'react';
import Carousel from 'react-elastic-carousel';
import Card from './extras/Card';

const breakpoints = [
	{width: 375, itemsToShow: 1, itemsToScroll: 1},
	{width: 480, itemsToShow: 2, itemsToScroll: 2},
	{width: 768, itemsToShow: 3, itemsToScroll: 3},
];

const imgs = [
	{img: 1},
	{img: 2},
	{img: 3},
	{img: 4},
	{img: 5},
	{img: 6},
	{img: 7},
	{img: 8},
	{img: 9},
	{img: 10},
	{img: 11},
	{img: 12},
	{img: 13},
	{img: 14},
	{img: 15},
	{img: 16},
	{img: 17},
	{img: 18},
	{img: 19},
	{img: 20},
	{img: 21},
	{img: 22},
	{img: 23},
	{img: 24},
	{img: 25},
	{img: 26},
	{img: 27},
	{img: 28},
	{img: 29},
	{img: 30},
	{img: 31},
	{img: 32},
	{img: 33},
];

const Galeria = React.memo(() => {
	return (
		<section className='galeria' id='galery'>
			<div className='galeria__container'>
				<h2 className='galeria__title'>Galería</h2>
				<div className='galeria__carousel'>
					<div className='galeria__carousel-normal'>
						<Carousel breakPoints={breakpoints} enableTilt>
							{imgs.map((img) => (
								<Card key={img.img} img={img.img} />
							))}
						</Carousel>
					</div>
					<div className='galeria__carousel-mobile'>
						<Carousel showArrows={false} breakPoints={breakpoints}>
							{imgs.map((img) => (
								<Card key={img.img} img={img.img} />
							))}
						</Carousel>
					</div>
				</div>
			</div>
		</section>
	);
});

export default Galeria;
